<template>
  <section>
    <v-container id="container" fluid>
      <v-row id="pariciones" align="center" justify="center" class="pt-5 pt-md-15">
        <v-col cols="12" md="8" class="pt-5 pt-md-15">
          <v-container class="fill-height">
            <v-row justify="left" class="mb-5">
              <v-col cols="11" class="py-0 mt-10 ml-md-15">
                <div class="d-inline-flex">
                  <v-img
                    contain
                    height="50"
                    class="mr-n15 pa-0"
                    src="@/assets/logos/horz/pariciones.svg"
                  ></v-img>
                </div>
                <div>
                  {{ $t("proyectos.pariciones") }}
                </div>
                <v-btn
                  href="https://pariciones.com"
                  target="_blank"
                  class="accent my-5"
                  >{{ $t("info.verSitio") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          md="4"
          align-self="center"
          class="pt-5 pt-md-15 shape verdeFondo"
        >
          <v-img
            contain
            height="300"
            src="@/assets/img/proyectos/pariciones/screen-pariciones.png"
          >
          </v-img>
        </v-col>
        <!-- <div class="my-10">
          <v-btn outlined class="ma-2" to="/tikgestion"
            >tikgestion<v-icon right>
              mdi-chevron-left
            </v-icon></v-btn
          >
          <v-btn outlined class="ma-2" to="/toi"
            ><v-icon left> mdi-chevron-right </v-icon>toi</v-btn
          >
        </div> -->
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Pariciones",
};
</script>

<style scoped>
#pariciones {
  min-height: 100vh;
}

.shape {
  border-radius: 30% 70% 67% 33% / 30% 30% 70% 70%;
  background-position: top left;
  width: 200px;
}
</style>
